 /*判断是ios还是安卓*/
  function judgeIosAndroid(){
    var u = navigator.userAgent,
      app = navigator.appVersion,
      isIOS ;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if(isAndroid){
      isIOS = false
    }else if(isiOS){
      isIOS = true
    }
    return isIOS
  }
  export { 
  // 很关键
  judgeIosAndroid
}


// WEBPACK FOOTER //
// ./src/assets/js/models.js